/* @ngInject */
export default class ClaimInstallerRedirectController {
    constructor(DialogService) {
        this.DialogService = DialogService;
        this.installerUrl = 'https://dt-installer.disruptive-technologies.com/';
    }

    close() {
        this.DialogService.cancel();
    }

    openInstaller() {
        window.open(this.installerUrl, '_blank');
        this.DialogService.cancel();
    }
}


